const ITENS = [
  "Laguna Alto Viçosa",
  "Chalés de Luxo",
  "Café da Manhã Incluso",
  "Hidromassagem",
  "Lareira",
  "Piscina Privativa",
  "Venda Nova do Imigrante — ES",
  "Decoração Romântica",
];

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-[#1C3026] bg-[#1C3026] py-4" data-testid="marquee">
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((metade) => (
          <div key={metade} className="flex" aria-hidden={metade === 1}>
            {ITENS.map((item, i) => (
              <span
                key={`${metade}-${i}`}
                className="mx-6 flex items-center gap-6 text-xs font-bold uppercase tracking-[0.3em] text-[#F6F5F2]/80"
              >
                {item} <span className="text-[#8C5A40]">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
